import React from 'react'

import { HooksList } from 'pages/developers/hooks/list/HooksList'

export const HooksListContainer: React.FC = () => {
  return <HooksList />
}
